// /api/orders/list/

import axios from './configAxios';

export const getOrders = async (url) => {
	return await axios.get(`${url}`);
};
//! Не актуально
